import { AgentFeature, AgentFeatureName } from '.'
import { AgentLanguage } from '../agent-language'

interface IsFeatureEnabledProps {
  readonly agentFeatures: AgentFeature[]
  readonly featureName: AgentFeatureName
  readonly language: AgentLanguage
}

interface IsFeatureEnabledForAllProps {
  readonly agentFeatures: AgentFeature[]
  readonly featureName: AgentFeatureName
  readonly languages: AgentLanguage[]
}

export function isFeatureEnabledForLanguage({
  agentFeatures,
  featureName,
  language
}: IsFeatureEnabledProps): boolean {
  const feature = agentFeatures.find(({ name }) => name === featureName)

  if (!feature) {
    // eslint-disable-next-line no-console
    console.warn(`Unable to find feature with name: ${featureName}`)
    return false
  }

  return feature.languages.some(
    (featureLanguage) => featureLanguage === language.getName()
  )
}

export function isFeatureEnabledForAllLanguages({
  agentFeatures = [],
  featureName,
  languages
}: IsFeatureEnabledForAllProps): boolean {
  const feature = agentFeatures.find(({ name }) => name === featureName)
  if (!feature) {
    // eslint-disable-next-line no-console
    console.warn(`Unable to find feature with name: ${featureName}`)
    return false
  }
  if (feature.languages.length !== languages.length) {
    return false
  }

  for (const language of languages) {
    let exists = false
    for (const agentLanguage of feature.languages) {
      exists = agentLanguage === language.getName()

      if (exists) {
        break
      }
    }

    if (!exists) {
      return false
    }
  }

  return true
}
